import axios from "axios";

// get request survey
export const getRequestSurveyService = async() => {
    return await axios.get('./data/domande.json').then(res => res.data)
}